import gaHttpStatus from '../common/google_analytics/http_status';
import karteCustonEventClient from '../common/karte/custom_event';

document.addEventListener('DOMContentLoaded', () => {
  const newDiv = document.getElementById('leaflets_new');
  if (newDiv == null) {
    return;
  }

  // チラシ投稿のタイムアウトになりそうなタイミングでエラーイベントを飛ばすようにする
  newDiv.addEventListener('submit', () => {
    const staffId = newDiv.dataset.staffId;
    const currentPath = newDiv.dataset.currentPath;
    setTimeout(() => {
      if (staffId && currentPath) {
        const d = new Date();
        const time = `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`.replace(/\n|\r/g, '');
        gaHttpStatus.return5xx({
          time,
          path: currentPath,
          staffId
        });
      }
    }, 55 * 1000);

    // KARTEに登録イベントを送信
    sendKarteEvent(
      'create_content',
      'leaflets',
      'チラシを新規で登録しました'
    );
  })

  const inputs = document.querySelectorAll('.leaflet-file-inputs');
  inputs.forEach(input => {
    input.addEventListener('change', () => {
      const filename: string = (input as HTMLInputElement).value || '';
      const contentType = filename.split(/\.(?=[^.]+$)/).pop();
      if (contentType == 'pdf') {
        return;
      }
      const nextFileInputId: string = (input as HTMLElement).dataset.nextFileInputId || '';
      const nextFileInput = document.getElementById(nextFileInputId);
      if (nextFileInput != null) {
        const div = (nextFileInput as HTMLElement).parentElement;
        const formGroup = (div as HTMLElement).parentElement;
        (formGroup as HTMLElement).style.display = 'block';
      }
    });
  });

  const sendKarteEvent = (event_name: string, content_name: string, message: string) => {
    // 投稿したことをKARTEに通知
    karteCustonEventClient.sendEvent({
      event_name: event_name,
      content_name: content_name,
      message: message
    });
  }
});
